import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '极速影视',
        url: 'https://chentaotao.cn',
        description: '极速不缓冲高清在线观看平台，秒开即播，追剧神器',
        foundingDate: '2020',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '朝阳区科技园区',
          addressLocality: '北京',
          addressCountry: 'CN',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '400-888-6666',
          contactType: 'customer service',
          email: 'contact@chentaotao.cn',
          availableLanguage: ['Chinese'],
        },
      },
      {
        '@type': 'WebPage',
        name: '关于我们 - 极速影视',
        description: '了解极速影视的品牌故事、发展历程和联系方式',
        url: 'https://chentaotao.cn/about',
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://chentaotao.cn' },
          { '@type': 'ListItem', position: 2, name: '关于我们' },
        ],
      },
    ],
  };

  const milestones = [
    { year: '2020', title: '极速影视成立', desc: '创始团队怀着"让每个人都能流畅追剧"的初心，在北京创立了极速影视平台。' },
    { year: '2021', title: '用户突破100万', desc: '凭借极速不缓冲的核心优势，平台注册用户迅速突破100万大关。' },
    { year: '2022', title: '内容库扩充', desc: '影视内容库突破10万部，覆盖电视剧、电影、动漫、综艺、纪录片等全品类。' },
    { year: '2023', title: '技术全面升级', desc: '引入AI智能推荐系统和4K超清画质，用户体验全面跃升。' },
    { year: '2024', title: '用户突破1000万', desc: '日活用户突破1000万，成为中国领先的免费在线影视平台之一。' },
  ];

  const testimonials = [
    {
      name: '追剧达人小王',
      text: '极速影视真的是我见过最快的平台了，秒开即播不是吹的！看《庆余年》全程无卡顿，推荐给所有追剧的朋友。',
      rating: 5,
    },
    {
      name: '电影爱好者老李',
      text: '用了极速影视两年了，资源全、画质好、不卡顿，周末在家看电影的首选。高清在线观看体验真的绝了。',
      rating: 5,
    },
    {
      name: '学生党小张',
      text: '免费看全集太香了！宿舍网速一般，但极速影视依然流畅播放不卡顿。课余时间追剧全靠它。',
      rating: 5,
    },
    {
      name: '职场人士陈姐',
      text: '通勤路上用手机看剧，极速高清不卡，追剧效率大大提升。收藏功能也很实用，追剧不迷路。',
      rating: 4,
    },
  ];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />

      <div className="pt-20 min-h-screen bg-background-50">
        <div className="w-full px-4 md:px-6 py-8">
          <div className="max-w-5xl mx-auto">
            <Breadcrumb items={[{ label: '关于我们' }]} />

            <section className="mt-8 mb-16">
              <div className="text-center mb-10">
                <h1 className="font-heading text-3xl md:text-4xl font-black text-foreground-900 mb-4">
                  关于极速影视
                </h1>
                <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                  极速影视是中国领先的免费在线影视平台，致力于为用户提供极速不缓冲、高清流畅的观影体验。
                  我们相信，好的内容值得被更多人看到。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
                <div className="bg-background-50 border border-background-200 rounded-2xl p-6 text-center">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100">
                    <i className="ri-flashlight-fill text-3xl text-primary-600"></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">极速不缓冲</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    先进的CDN加速和智能码率自适应技术，确保秒开即播，告别卡顿等待。
                  </p>
                </div>
                <div className="bg-background-50 border border-background-200 rounded-2xl p-6 text-center">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-accent-100">
                    <i className="ri-hd-line text-3xl text-accent-600"></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">高清画质</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    支持1080P全高清甚至4K超清画质，给你影院级的视觉享受。
                  </p>
                </div>
                <div className="bg-background-50 border border-background-200 rounded-2xl p-6 text-center">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-secondary-100">
                    <i className="ri-vip-crown-line text-3xl text-secondary-600"></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">免费观看</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    海量影视资源全部免费在线观看，无需付费，无需会员，随时随地畅享精彩内容。
                  </p>
                </div>
              </div>

              <div className="relative rounded-2xl overflow-hidden mb-12">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20office%20team%20collaborating%20around%20large%20monitors%20displaying%20video%20content%2C%20creative%20workspace%20with%20warm%20lighting%2C%20tech%20company%20culture%2C%20cinematic%20wide%20shot%2C%20professional%20atmosphere&width=1600&height=600&seq=about-banner&orientation=landscape"
                  alt="极速影视团队"
                  title="极速影视团队 - 用心做好每一帧"
                  className="w-full aspect-[21/9] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-8">
                  <p className="text-background-50 text-lg md:text-xl font-heading font-bold">
                    用心做好每一帧，让追剧成为一种享受
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-16">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
                发展历程
              </h2>
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200 -translate-x-1/2 hidden md:block"></div>
                <div className="flex flex-col gap-6">
                  {milestones.map((item, index) => (
                    <div
                      key={index}
                      className={`flex flex-col md:flex-row gap-4 ${
                        index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                      }`}
                    >
                      <div className="md:w-1/2"></div>
                      <div className="relative flex items-center justify-center">
                        <div className="w-3 h-3 rounded-full bg-primary-500 ring-4 ring-primary-100 z-10"></div>
                      </div>
                      <div className="md:w-1/2 bg-background-50 border border-background-200 rounded-xl p-5">
                        <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-bold mb-2">
                          {item.year}
                        </span>
                        <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">
                          {item.title}
                        </h3>
                        <p className="text-sm text-foreground-500 leading-relaxed">
                          {item.desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="mb-16">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {testimonials.map((item, index) => (
                  <div
                    key={index}
                    className="bg-background-50 border border-background-200 rounded-2xl p-6"
                  >
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-sm ${
                            i < item.rating
                              ? 'ri-star-fill text-accent-500'
                              : 'ri-star-line text-foreground-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4 italic">
                      &ldquo;{item.text}&rdquo;
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 font-bold text-sm">
                        {item.name.charAt(0)}
                      </div>
                      <span className="text-sm font-medium text-foreground-800">{item.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
                联系我们
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-background-50 border border-background-200 rounded-2xl p-8">
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-6">
                    联系方式
                  </h3>
                  <div className="flex flex-col gap-5">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                        <i className="ri-mail-line text-primary-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">电子邮箱</p>
                        <p className="text-sm text-foreground-500">contact@chentaotao.cn</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 flex-shrink-0">
                        <i className="ri-phone-line text-accent-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">客服电话</p>
                        <p className="text-sm text-foreground-500">400-888-6666</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 flex-shrink-0">
                        <i className="ri-map-pin-line text-secondary-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">公司地址</p>
                        <p className="text-sm text-foreground-500">北京市朝阳区科技园区创新大厦18层</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                        <i className="ri-time-line text-primary-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">工作时间</p>
                        <p className="text-sm text-foreground-500">周一至周日 9:00 - 21:00</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-background-100 border border-background-200 rounded-2xl p-8">
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-6">
                    商务合作
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                    如果您有广告投放、内容合作、版权合作等商务需求，欢迎通过以下方式联系我们。
                    我们期待与您携手共创共赢。
                  </p>
                  <div className="flex flex-col gap-4">
                    <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl border border-background-200">
                      <i className="ri-shake-hands-line text-2xl text-primary-500"></i>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">广告合作</p>
                        <p className="text-xs text-foreground-500">ads@chentaotao.cn</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl border border-background-200">
                      <i className="ri-film-line text-2xl text-accent-500"></i>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">内容合作</p>
                        <p className="text-xs text-foreground-500">content@chentaotao.cn</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl border border-background-200">
                      <i className="ri-copyright-line text-2xl text-secondary-500"></i>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">版权合作</p>
                        <p className="text-xs text-foreground-500">copyright@chentaotao.cn</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}